<template>
  <router-view />
  <template v-if="$store.state.AuthModule.user.show_contact_info">
    <a
      href="https://t.me/smstw88"
      target="_blank"
      rel="noopener noreferrer"
      class="floating-telegram-btn"
      title="聯繫我們"
    >
      <i class="bi bi-chat-dots-fill"></i>
    </a>
  </template>
</template>

<script lang="ts">
import { defineComponent, nextTick, onMounted } from "vue";
import { useStore } from "vuex";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { themeMode } from "@/core/helpers/config";
import { initializeComponents } from "@/core/plugins/keenthemes";
export default defineComponent({
  name: "app",
  setup() {
    const store = useStore();

    onMounted(() => {
      /**
       * Overrides the layout config using saved data from localStorage
       * remove this to use static config (@/core/config/DefaultLayoutConfig.ts)
       */
      store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);

      /**
       *  Sets a mode from configuration
       */
      store.dispatch(Actions.SET_THEME_MODE_ACTION, themeMode.value);

      nextTick(() => {
        initializeComponents();

        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      });
    });
  },
});
</script>

<style lang="scss">
@import "~bootstrap-icons/font/bootstrap-icons.css";
@import "~apexcharts/dist/apexcharts.css";
@import "~quill/dist/quill.snow.css";
@import "~animate.css";
@import "~sweetalert2/dist/sweetalert2.css";
@import "~nouislider/distribute/nouislider.css";
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "~socicon/css/socicon.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "~dropzone/dist/dropzone.css";
@import "~@vueform/multiselect/themes/default.css";
@import "~prism-themes/themes/prism-shades-of-purple.css";
@import "~element-plus/dist/index.css";

//RTL version styles
//@import "assets/css/style.rtl.css";

.floating-telegram-btn {
  position: fixed;
  bottom: 90px;
  right: 30px;
  width: 60px;
  height: 60px;
  background: #4ade80;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 9999;
  text-decoration: none;

  i {
    font-size: 28px;
    color: #ffffff;
  }

  &:hover {
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 8px 20px rgba(74, 222, 128, 0.6);
    background: #22c55e;
  }
  &:active {
    transform: translateY(-2px) scale(1.02);
  }
}

@media (max-width: 768px) {
  .floating-telegram-btn {
    width: 50px;
    height: 50px;
    bottom: 80px;
    right: 20px;

    i {
      font-size: 24px;
    }
  }
}
</style>
